export default __webpack_public_path__ + "static/media/grey-cars-traffic.99108fcc.png";